import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ConfigProvider } from 'antd';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import './assets/style/custom.css';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
	// <React.StrictMode>
	<ConfigProvider
		theme={{
			token: {
				// Seed Token
				colorPrimary: '#ff6f00',
				colorInfo: '#ff6f00',
				// Alias Token
				// colorBgContainer: '#f6ffed',
			},
		}}
	>
		<App />
	</ConfigProvider>
	// </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
